import { Injectable } from "@nestjs/common";
import { EnquiriesRepository } from "./repositories/enquiries.repo";
import { EnQuiryManagementResponse, EnquiryAssessmentInfoModel, EnquiryAssessmentInfoReq, EnquiryAssessmentResponseModel, EnquiryAssessmentUpdateReq, EnquiryByIdModel, EnquiryIdreq, EnquiryLifecycleStatusEnum, EnquiryPackBomModel, EnquiryProductModel, EnquirymanagementReq, FreezeUnFreezeInfoReq, LeadProductInfoModel, enquiryInfo, getAllEnquiryInfoReq } from "@gtpl/shared-models/enquiry-management";
import { AllCountriesResponseModel, AllDestinationsResponseModel, AllUnitcodeResponseModel, CommonResponse, CountryDto, DestinationDto, UnitcodeDto } from "@gtpl/shared-models/masters";
import { InjectRepository } from "@nestjs/typeorm";
import { EnquiriesEntity } from "./entites/enquiries";
import { In, Repository, Transaction, getManager } from "typeorm";
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { get } from "http";
import { currentId } from "async_hooks";
import { EnquiryProdctsEntity } from "./entites/enquiry-products";
import moment from "moment";
import { whatsApp } from '../../../../whatsapp'
import { GlobalVariableValues, MessageParameters } from "@gtpl/shared-models/common-models";
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { EnquiryLogEntity } from "./entites/enquiry-log";
import { map } from "rxjs/operators";
import { async } from "rxjs/internal/scheduler/async";
import { EnquiryPackBomEntity } from "./entites/enquiry-pack-bom.entity";
import { EnquiriesProductsRepository } from "./repositories/enquiry-products-repo";
import { isNull } from "util";
import appSettings from "apps/services/config";
import { UnitsOfWeightInput } from "@gtpl/shared-models/sale-management";

@Injectable()
export class EnquiriesService {
    constructor(
        private readonly  enquiryRepo: EnquiriesRepository ,
        private logService:LogsService,
        private wpService: WhatsAppNotificationService,
    private wtsAppBroadCatService: WhatsappBroadCastService,
        @InjectRepository(EnquiryLogEntity)
        private enquiryLogRepo: Repository<EnquiryLogEntity> ,
        private  enquiryProductRepo: EnquiriesProductsRepository
    //     @InjectRepository(EnquiryProdctsEntity)
    // private enquiryProductRepo: Repository<EnquiryProdctsEntity>,
        
    ) {}

    async getAllEnquiriesByStatus(req:EnquiryAssessmentInfoReq):Promise<EnquiryAssessmentResponseModel>{
        try{
            // const enquiryInfo = await this.enquiryRepo.find({where:{lifeCycleStatus:req.status}}) 
            const enquiryInfo = await this.enquiryRepo.getAllEnquiriesByStatus(req)
            let data : EnquiryAssessmentInfoModel[] = []
            if(enquiryInfo.length > 0){
                for(const rec of enquiryInfo){
                    data.push(new EnquiryAssessmentInfoModel(rec.enquiry_id,rec.enquiry_number,rec.source_from,rec.client_name,rec.end_customer_name,rec.etd,rec.unit_name,rec.country_name,rec.destination_name,rec.enquiry_date,rec.life_cycle_status))
                }
                const newLogDto = new LogsDto(1,'view','Enquiry Assessment',0,true,'Enquiries Data retrieved successfully',req.createdUser)
                let logEntry = await this.logService.createLog(newLogDto)
                return new EnquiryAssessmentResponseModel(true,1,'Data retrieved',data)

            }else{
                return new EnquiryAssessmentResponseModel(false,0,'No data found')
            }

        }catch(err){
            throw err
        }
    }

    async updateEnquiryAssesmentStatus(req:EnquiryAssessmentUpdateReq):Promise<EnquiryAssessmentResponseModel>{
        const transactionManager = new GenericTransactionManager()
        try{
            await transactionManager.startTransaction()
            // let saveFlag : Set<boolean>
            const updateStatus = await transactionManager.getRepository(EnquiriesEntity).update({enquiryId:req.id},{lifeCycleStatus:req.status,enquiryRejectReason:req.rejectReason,enquiryRejectDescription:req.rejectDescription})
            // const updateStatus = await this.enquiryRepo.update({enquiryId:req.id},{lifeCycleStatus:req.status,enquiryRejectReason:req.rejectReason})
            if(updateStatus.affected){
                // const enquiryDetails = await this.enquiryRepo.getEnquiryInfoByEnquiryId(req.id)
                const enquiryDetails = await transactionManager.getCustomRepository(EnquiriesRepository).getEnquiryInfoByEnquiryId(req.id)
                const enquiryLogObj = new EnquiryLogEntity()
                const enquiry = new EnquiriesEntity()
                enquiry.enquiryId = req.id
                enquiryLogObj.enquiryEntity = enquiry
                enquiryLogObj.enquiryNumber = enquiryDetails[0].enquiryNumber
                enquiryLogObj.enquiryStatus = req.status
                const enquiryLogUpdate = await transactionManager.getRepository(EnquiryLogEntity).save(enquiryLogObj)
                if(!enquiryLogUpdate){
                    await transactionManager.releaseTransaction()
                    return new EnquiryAssessmentResponseModel(false,0,'Something went wrong in Enquiry Log Updation')
                }else{
                    const newLogDto = new LogsDto(enquiryDetails[0].unitId,'Update','Enquiry Assessment',0,true,`${req.status == EnquiryLifecycleStatusEnum.UNDER_ASSESMENT ? 'Enquiry Assessement status updated successfully' : req.status == EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED ? 'Enquiry Assessement Accepted successfully' : req.status == EnquiryLifecycleStatusEnum.ASSESMENT_REJECTED ? 'Enquiry Assessment Rejected successfully' : ''}`,req.createdUser,req.status == EnquiryLifecycleStatusEnum.UNDER_ASSESMENT ? EnquiryLifecycleStatusEnum.OPEN : req.status == EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED || req.status == EnquiryLifecycleStatusEnum.ASSESMENT_REJECTED ? EnquiryLifecycleStatusEnum.UNDER_ASSESMENT : '',req.status)
                    let logEntry = await this.logService.createLog(newLogDto)
                    if(!logEntry.status){
                    await transactionManager.releaseTransaction()
                    return new EnquiryAssessmentResponseModel(false,0,'Something went wrong in User Log Creation')
                    }else{
                       let whatsappmessageStatus 
                    if(req.status === EnquiryLifecycleStatusEnum.ASSESMENT_REJECTED){
                    const datetime = moment().subtract(0, "days").format('MMMM Do, YYYY')
                    let data : any = ''
                    let messageContent = 'Enquiry Number' + ': *' + enquiryDetails[0].enquiryNumber + 
                    "*\\n"+ 'Country' + ': *' +enquiryDetails[0].countryName + 
                    "*\\n"+ 'Destination' + ': *' +enquiryDetails[0].destinationName + 
                    "*\\n"+ 'Unit' + ': *' +enquiryDetails[0].unitName + 
                    "*\\n"+ 'Buyer' + ': *' +enquiryDetails[0].buyerName + 
                    "*\\n"+ 'Reject Reason' + ': *' +req.rejectReasonName  +
                     "*\\n"+ 'Reject Description' + ': *' +req.rejectDescription 
                    data += messageContent
            
                                const parameters = [
                                    { "type": "text", "text": datetime},
                                    {"type": "text", "text": data }
                                ]
            
                                const contact = '917702262256'
                                const whatsappReq = await new MessageParameters(contact,'rejected_enquiry_report',parameters,'en_us')
                                const messageStatus = await this.wpService.sendMessageThroughFbApi(whatsappReq)
                                console.log(messageStatus,'-------messagestatus')
                                if(!messageStatus.status){
                                    whatsappmessageStatus = false
                                    // await transactionManager.releaseTransaction()
                                    // return new EnquiryAssessmentResponseModel(false,0,'Something went wrong in sending Whatsapp notification to buyer')
                                }else{
                                    whatsappmessageStatus = true
                                    const whatsapplogDto = new WhatsAppLogDto(contact,'rejected_enquiry_report','BMR',GlobalVariableValues.companyId,GlobalVariableValues.enquiryModuleId)
                                    const whatsappRes = await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                                    // if(!whatsappRes){
                                    //     await transactionManager.releaseTransaction()
                                    //     return new EnquiryAssessmentResponseModel(false,0,'Soemthign went wrong in whatsapplog updation')
                                    // }
                                }
            
                    }
                    await transactionManager.completeTransaction()
                    return new EnquiryAssessmentResponseModel(true,1,`${req.status == EnquiryLifecycleStatusEnum.UNDER_ASSESMENT ? 'Enquiry Assessement status updated successfully' : req.status == EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED ? 'Enquiry Assessement Accepted successfully' : req.status == EnquiryLifecycleStatusEnum.ASSESMENT_REJECTED && whatsappmessageStatus == true? 'Enquiry Assessment Rejected successfully' : req.status == EnquiryLifecycleStatusEnum.ASSESMENT_REJECTED && whatsappmessageStatus == false ? 'Enquiry Assessment Rejected successfully but soemthing went wrong in sending whatsapp notification to buyer' : ''}`)
                    }
                }
             
            }else{
                await transactionManager.releaseTransaction()
                return new EnquiryAssessmentResponseModel(false,0,'Something went worng in enquiry status updation')
            }
            // if(!(saveFlag.has(false))){
            //     await transactionManager.completeTransaction()
            //     return new EnquiryAssessmentResponseModel(true,1,`${req.status == EnquiryLifecycleStatusEnum.UNDER_ASSESMENT ? 'Enquiry Assessement status updated successfully' : req.status == EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED ? 'Enquiry Assessement Accepted successfully' : req.status == EnquiryLifecycleStatusEnum.ASSESMENT_REJECTED ? 'Enquiry Assessment Rejected successfully' : ''}`)
            // }else{
            //     console.log('ooooooooooooooooooooooooooooo')
            //     await transactionManager.releaseTransaction()
            //     return new EnquiryAssessmentResponseModel(false,0,'Something went wrong')
            // }
        }catch(err){
            await transactionManager.releaseTransaction()
            return new EnquiryAssessmentResponseModel(false,0,'Something went wrong')

        }
    }
    async createEnquiry(req: EnquirymanagementReq, isUpdate): Promise<CommonResponse> {
        console.log(req, 'Value of req.enquiryId');
        console.log(isUpdate, 'Value of isUpdate');
        const transManager = new GenericTransactionManager();
        try {
            await transManager.startTransaction();
            const enquiry = new EnquiriesEntity();

            const getId = await this.enquiryRepo.getmaxId();
            if (getId !== undefined) {
                enquiry.enquiryNumber = "ENQ" + '-' + Number(getId.enquiryId).toString().padStart(3, '0');
            }

            // enquiry.orderType = req.orderType;
            enquiry.sourceFrom = req.sourceFrom;
            enquiry.agentId = req.agentId;
            enquiry.buyerId = req.buyerId;
            enquiry.salePersonId = req.salePersonId;
            enquiry.enquiryDate = req.enquiryDate;
            enquiry.noOfContainers = req.noOfContainers;
            enquiry.agentAddressId = req.agentAddressId;
            enquiry.buyerAddressId = req.buyerAddressId;
            enquiry.countryId = req.countryId;
            enquiry.destinationId = req.destinationId;
            enquiry.etd = req.etd;
            enquiry.toEtd = req.toEtd;
            enquiry.eta = req.eta;
            enquiry.deliveryTermsId = req.deliveryTermsId;
            enquiry.shipmentTermsId = req.shipmentTermsId;
            enquiry.paymentTermsId = req.paymentTermsId;
            enquiry.processingUnitId = req.processingUnitId;
            enquiry.manufacturingUnitId = req.manufacturingUnitId;
            enquiry.currencyId = req.currencyId;
            enquiry.remarks = req.remarks;
            enquiry.enquiryRejectReason = req.enquiryRejectReason;
            enquiry.salesCommission = req.salesCommission;
            enquiry.uomId = req.uomId;
            enquiry.unitId = req.unitId;
            enquiry.isFOB = req.isFOB
            if (isUpdate) {
                enquiry.updatedUser = req.updateUser;
                enquiry.enquiryNumber = req.enquiryNumber;
                enquiry.enquiryId=req.enquiryId
            } else {
                enquiry.createdUser = req.createdUser;
            }
            let ProductDetails = []
            if (req.productDetails?.length > 0) {
                for (const item of req.productDetails) {

                    console.log(item,'@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@')
                    // item.productId=64
                    const product = new EnquiryProdctsEntity();
                    product.category = item.category;
                    product.brandId = item.brandId;
                    product.variantId = item.variantId;
                    product.packStyleId = item.packstyleId;
                    product.styleWeighment = item.styleWeighment;
                    product.unitPrice = item.unitPrice;
                    product.noOfCase = item.noOfCases;
                    product.caseWeight = item.caseWeight;
                    product.netWeight = item.netWeight;
                    product.netAmount = item.netAmount;
                    product.noOfSkewers = item.noOfSkewers;
                    product.varietyId = item.varietyId;
                    product.packCount = item.packCount
                    product.orderType = item.orderType;
                    product.netShrimpWeight = item.shrimpWeight
                    product.uomId=item.uomId
                    product.packMaterialCost = item.packMaterialCost
                    product.group = item.grouping
                    product.noOfContainers = item.noOfContainers ? item.noOfContainers : 0
                    product.uvPriceCategory = item.uvPriceCategory
                    product.uvType = item.uvType
                    product.uvPercentOrCent = item.uvPercentOrCent
                    product.brandType = item.brandType
                    product.priceBasedOn = item.priceBasedOn == 'LBS' ? UnitsOfWeightInput.find(e => e.name == 'lb').value : UnitsOfWeightInput.find(e => e.name == 'kg').value
                    if (isUpdate) {
                        product.enquiryProductId = item.productId;
                    }else{

                    }
                    ProductDetails.push(product);
                }
            }
            enquiry.enquiryProduct = ProductDetails

            // let PackBomDetails = []
            // if (req.enquiryPackBom?.length > 0) {
            //     for (const item of req.enquiryPackBom) {
            //         const packBomEntity = new EnquiryPackBomEntity();
            //         item.id=77
            //         packBomEntity.itemCategoryId = item.itemCategoryId;
            //         packBomEntity.itemSubCategoryId = item.itemSubCategoryId;
            //         packBomEntity.itemId = item.itemId;
            //         packBomEntity.quantity = item.quantity;
            //         if(isUpdate){
            //             console.log(req.enquiryId,'asdfghjkl',isUpdate)
            //             packBomEntity.id = item.id
            //         }
            //         PackBomDetails.push(packBomEntity);
            //     }
            // }
            // enquiry.enquiryPackInfo = PackBomDetails;

            const save = await this.enquiryRepo.save(enquiry);

            console.log(save,']]]]]]]]]]]]]]]]]')
            if (save) {
                const logentity = new EnquiryLogEntity();
                if(isUpdate){
                    console.log('00000000000000000000000000000000000',req.enquiryNumber)
                    logentity.enquiryNumber = req.enquiryNumber
                }else{
                    logentity.enquiryNumber = save.enquiryNumber
                }
                logentity.enquiryStatus = EnquiryLifecycleStatusEnum.OPEN;
                const ent = new EnquiriesEntity()
                ent.enquiryId=save.enquiryId
                logentity.enquiryEntity=ent
                const savelog = await this.enquiryLogRepo.save(logentity);
                const newLogDto = new LogsDto(1, 'Create', 'Enquiries', save.enquiryId, true, '', req.createdUser);
                let res = await this.logService.createLog(newLogDto);
                if (savelog && res) {
                    await transManager.releaseTransaction();
                    return new CommonResponse(true, 1, 'Enquiry created Successfully');
                } else {
                    await transManager.releaseTransaction();
                    return new CommonResponse(false, 0, 'Something Went Wrong');
                }
            } else {
                await transManager.releaseTransaction();
                return new CommonResponse(false, 0, 'Something Went Wrong');
            }
        } catch (err) {
            throw err;
        }
    }

    async getEnquiryNumberDropdown():Promise<CommonResponse>{
        try{
            const info = await this.enquiryRepo.find({select:['enquiryNumber','enquiryId','freezeStatus']})
            if(info.length > 0){
                return new CommonResponse(true,1,'Data retreievd',info)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    } 


    async getEnquiryDropdownForEnquiryAssessment():Promise<CommonResponse>{
        try{
            // const info = await this.enquiryRepo.find({select:['enquiryNumber','enquiryId','freezeStatus'],where:{lifeCycleStatus:In([EnquiryLifecycleStatusEnum.OPEN,EnquiryLifecycleStatusEnum.UNDER_ASSESMENT,EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED])}})
            const info = await this.enquiryRepo.getEnquiryDropdownForEnquiryAssessment()
            if(info.length > 0){
                return new CommonResponse(true,1,'Data retreievd',info)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getCostSheetEnquiryNumberDropdown():Promise<CommonResponse>{
        try{
            // const info = await this.enquiryRepo.find({select:['enquiryNumber','enquiryId','freezeStatus'],where:{lifeCycleStatus:In([EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED,EnquiryLifecycleStatusEnum.ACCEPTED,EnquiryLifecycleStatusEnum.RENEGOTIATED])}})
            const info = await this.enquiryRepo.getCostSheetEnquiryNumberDropdown()
            if(info.length > 0){
                return new CommonResponse(true,1,'Data retreievd',info)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getCountryDropdown():Promise<AllCountriesResponseModel>{
        try{
            // const info = await this.enquiryRepo.find({select:['countryId']})
            const info = await this.enquiryRepo.getCountryInfoDropdown()
            let data = []
            if(info.length > 0){
                for(const rec of info){
                    data.push(new CountryDto(rec.countryId,rec.countryName,null,null,true))
                }
                return new AllCountriesResponseModel(true,1,'Data retreievd',data)
            }else{
                return new AllCountriesResponseModel(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getDestinationDropdown():Promise<AllDestinationsResponseModel>{
        try{
            // const info = await this.enquiryRepo.find({select:['destinationId']})
            const info = await this.enquiryRepo.getDestinationInfoDropdown()
            let data = []
            if(info.length > 0){
                for(const rec of info){
                    data.push(new DestinationDto(rec.destinationId,rec.destinationName,0,null,null,null,null,null,null))
                }
                return new AllDestinationsResponseModel(true,1,'Data retreievd',data)
            }else{
                return new AllDestinationsResponseModel(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getUnitDropdown():Promise<AllUnitcodeResponseModel>{
        try{
            // const info = await this.enquiryRepo.find({select:['unitId']})
            const info = await this.enquiryRepo.getUnitInfoDropdown()
            let data = []
            if(info.length > 0){
                for(const rec of info){
                    data.push(new UnitcodeDto(rec.unitId,rec.unitName,null,null,null))
                }
                return new AllUnitcodeResponseModel(true,1,'Data retreievd',data)
            }else{
                return new AllUnitcodeResponseModel(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }
    async getEnquiryLogsAging(enquiryId:number):Promise<CommonResponse>{
        const manager=getManager()
        const query='SELECT MAX(enquiry_log_id),MAX(enquiry_log_id)-1,DATEDIFF((SELECT created_at FROM enquiry_log WHERE enquiry_log_id=(SELECT MAX(enquiry_log_id) FROM enquiry_log)), (SELECT created_at FROM enquiry_log WHERE enquiry_log_id=(SELECT MAX(enquiry_log_id)-1 FROM enquiry_log))) AS diff     FROM  enquiry_log where enquiry_id='+enquiryId+''
        const res = await manager.query(query)
        return new CommonResponse(true,1,'',res)
    }
    async getAllEnquiriesInfo(req:getAllEnquiryInfoReq):Promise<EnQuiryManagementResponse>{
        try{
            const enqmap = new Map<number,enquiryInfo>()
            const manager = getManager()
            let query=`SELECT e.enquiry_id as enquiryId,e.enquiry_id as enquiryId,d.destination_name AS destination,u.unit_name AS unit,cn.country_name AS country,ed.employee_name AS salePerson,ec.end_customer_name AS endCustomer,c.client_name AS customer,enquiry_number AS enquiryNumber,order_type AS orderType,source_from AS sourceFrom,agent_id AS agentId,buyer_id AS buyerId,sale_person_id AS salePersionId,e.enquiry_date AS enquiryDate,e.no_of_containers AS noOfContainers,e.agent_address_id AS agentAddressid,buyer_address_id AS buyerAddressId,e.country_id AS countryId,e.destination_id AS destinationId,etd,to_etd as toEtd,eta,delivery_terms_id AS deliveryTermsId, shipment_terms_id AS shipmentTermsId,e.unit_id,life_cycle_status AS lifeCycleStatus,DATEDIFF(DATE(NOW()),e.enquiry_date) AS aging,e.is_fob as isFOB,e.cancel_reason AS cancelReason FROM ${appSettings.enquiry_db}.enquiries e LEFT JOIN ${appSettings.masters_db}.customers c ON e.agent_id=c.cust_id LEFT JOIN ${appSettings.masters_db}.end_customers ec ON e.buyer_id=ec.end_customer_id  LEFT JOIN ${appSettings.masters_db}.employee_details ed ON ed.employee_id=e.sale_person_id  LEFT JOIN ${appSettings.masters_db}.countries cn ON  cn.country_id=e.country_id LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=e.unit_id LEFT JOIN ${appSettings.masters_db}.destination d ON d.destination_id=e.destination_id where enquiry_id > 0 `
            if(req.tabName != undefined){
                if(req.tabName == 'OPEN'){
                    query=query+' and life_cycle_status NOT IN("CLOSED","CANCELLED")'
                }
                if(req.tabName == 'CLOSED'){
                    query= query+' and life_cycle_status IN("CLOSED")'
                }
                if(req.tabName == 'CANCELLED'){
                    query= query+' and life_cycle_status IN("CANCELLED")'
                }
            }
            if(req.countryId != undefined){
                query=query+' and e.country_id ='+req.countryId+''
            }
            if(req.destinationId != undefined){
                query =query+' and e.destination_id='+req.destinationId+''
            }
            if(req.enquiryNo != undefined){
                query=query+' and e.enquiry_number ="'+req.enquiryNo+'"'
            }
            if(req.status != undefined){
                query=query+' and e.life_cycle_status ="'+req.status+'"'
            }
            if(req.unitId != undefined){
                query=query+' and e.unit_id='+req.unitId+''
            }
            query=query + ` ORDER BY e.enquiry_number`
            
            const result = await manager.query(query)
            for(const rec of result){
                // const aging = await this.enquiryRepo.getEnquiryLogsAging(rec.enquiryId)
                // console.log(aging,'###################')
                if(!enqmap.has(rec.enquiryId)){
                    enqmap.set(rec.enquiryId,new enquiryInfo(rec.enquiryId,rec.enquiryNumber,rec.orderType,rec.sourceFrom,rec.agentId,rec.customer,rec.buyer_id,rec.endCustomer,rec.salePersionId,rec.salePerson,rec.enquiryDate,rec.noOfContainers,rec.agentAddressId,rec.agentAddress,rec.buyerAddresId,rec.buyerAddres,rec.countryId,rec.country,rec.destinationId,rec.destination,rec.etd,rec.toEtd,rec.eta,rec.deliveryTermsId,'',undefined,undefined,undefined,undefined,undefined,undefined,undefined,undefined,rec.currency,rec.remarks,rec.createdUser,undefined,rec.lifeCycleStatus,rec.unitId,undefined,[],rec.aging,undefined,rec.unit,rec.isFOB == 0 ? false : true,rec.cancelReason))
                }
            }
           const info: enquiryInfo[] = []
           enqmap.forEach(rec =>{
            info.push(rec)
        })

            return new CommonResponse(true,1,'Data Retrived Sucessfully',info)
        }catch(err){
            throw err
        }

    }
    async getEnquiryById(req:EnquiryIdreq):Promise<EnQuiryManagementResponse>{
        try{
            const manager=getManager()
            const query=`SELECT 
            ep.enquiry_id AS enquiryId,
            e.enquiry_id,
            enquiry_number AS enquiryNumber,
            cn.country_name AS countryName,
            d.destination_name AS destinationName,
            u.unit_name AS unit,
            source_from AS sourceFrom,
            cc.client_name AS agentName,
            ecc.end_customer_name AS buyerName,
            life_cycle_status AS lifeCycleStatus,
            DATEDIFF(DATE(NOW()),e.enquiry_date) AS aging,
            
            ep.order_type AS orderType,
            ed.employee_name AS salePersonName,
            enquiry_date AS enquiryDate,
            ep.no_of_containers AS noOfContainers,
            CONCAT(addr.add_line_one, addr.add_line_two, addr.add_line_three, addr.add_line_four) AS agentAddress,
            CONCAT(addr.add_line_one, addr.add_line_two, addr.add_line_three, addr.add_line_four) AS buyerAddres,
            etd,eta,
            dtt.delivery_terms_name AS deliveryTerms,
            pt.payment_terms_name AS paymentTerms,
            st.shipping_term_name AS shipmentTerms,
            puc.unit_name AS procesingUnitName,
            muc.unit_name AS manufacturingUnitName,
            ccn.currency_name AS currency,
            remarks,
            pl.unit_name AS unitName,
            enquiry_reject_reason AS EnquiryRejectReason,
            
            category AS category,
            brand_name AS brandName,
            variant_name AS variantCode,
            packing_method_name AS packstyle,
            style_weighment AS styleWeighment,
            unit_price AS unitPrice,
            no_of_case AS noOfCases,
            case_weight AS caseWeight,
            net_weight AS netWeight,
            net_amount AS netAmount,
            no_of_skewers AS noOfSkewers,
            variety_id AS varietyId,
            enquiry_product_id AS productId,
            ep.brand_id AS brandId,
            ep.variant_id AS variantId,
            ep.pack_style_id AS packstyleId,
            

            agent_id AS agentId,
            buyer_id AS buyerId,
            sale_person_id AS salePersionId,
            agent_address_id AS agentAddressId,
            buyer_address_id AS buyerAddresId,
            e.country_id AS countryId,
            e.destination_id AS destinationId,
            dtt.delivery_terms_id AS deliveryTermsId,
            shipment_terms_id AS shipmentTermsId,
            e.unit_id AS unitId,
            si.size_name AS varietyName
            
            FROM ${appSettings.enquiry_db}.enquiry_products ep
            
            LEFT JOIN ${appSettings.enquiry_db}.enquiries e ON e.enquiry_id=ep.enquiry_id
            LEFT JOIN ${appSettings.masters_db}.customers c ON e.agent_id=c.cust_id
                         LEFT JOIN ${appSettings.masters_db}.end_customers ec ON e.buyer_id=ec.end_customer_id
                         LEFT JOIN ${appSettings.masters_db}.employee_details ed ON ed.employee_id=e.sale_person_id
                         LEFT JOIN ${appSettings.masters_db}.countries cn ON  cn.country_id=e.country_id
                         LEFT JOIN ${appSettings.masters_db}.unitcodes u ON u.unit_code_id=e.unit_id
                         LEFT JOIN ${appSettings.masters_db}.destination d ON d.destination_id=e.destination_id
                         LEFT JOIN ${appSettings.masters_db}.end_customers ecc ON ecc.end_customer_id=e.buyer_id
                         LEFT JOIN ${appSettings.masters_db}.customers cc ON cc.cust_id=e.agent_id
                         LEFT JOIN ${appSettings.masters_db}.shipping_terms st ON st.shipping_term_id=e.shipment_terms_id
                         LEFT JOIN ${appSettings.masters_db}.currencies ccn ON ccn.currency_id=e.currency_id
                         LEFT JOIN ${appSettings.masters_db}.delivery_terms dtt ON dtt.delivery_terms_id=e.delivery_terms_id
                         LEFT JOIN ${appSettings.masters_db}.payment_terms pt ON pt.payment_terms_id=e.payment_terms_id
                         LEFT JOIN ${appSettings.masters_db}.address addr ON addr.cust_id=e.agent_address_id
                         LEFT JOIN ${appSettings.masters_db}.address baddr ON baddr.cust_id=e.buyer_address_id
                         LEFT JOIN ${appSettings.masters_db}.unitcodes puc ON puc.unit_code_id=e.processing_unit_id
                         LEFT JOIN ${appSettings.masters_db}.unitcodes muc ON muc.unit_code_id=e.manufacturing_unit_id
                         LEFT JOIN ${appSettings.masters_db}.unitcodes pl ON pl.unit_code_id=e.unit_id
                         LEFT JOIN ${appSettings.masters_db}.brands br ON br.brand_id=ep.brand_id
                         LEFT JOIN ${appSettings.masters_db}.variant vr ON vr.variant_id=ep.variant_id 
                         LEFT JOIN ${appSettings.masters_db}.sizes si ON si.size_id= variety_id
                         LEFT JOIN ${appSettings.masters_db}.packing_methods ps ON ps.packing_method_id=ep.pack_style_id
                         where ep.enquiry_id =${req.enquiryid}
                         `
                         console.log(query,"55555555")
            const result = await manager.query(query)
            console.log(result,"66666666")

            return new EnQuiryManagementResponse(true,1,'Data retrived Sucessfully',result)

        }catch(err){
            throw err
        }
    }

    async cancelEnquiry(req: EnquiryAssessmentInfoModel):Promise<EnquiryAssessmentResponseModel>{
        try{
            const enquiryData = await this.enquiryRepo.findOne({where:{enquiryId:req.enquiryId}})
            if(enquiryData){
                const updateEnquiry = await this.enquiryRepo.update({enquiryId: req.enquiryId},{lifeCycleStatus: EnquiryLifecycleStatusEnum.CANCELLED,cancelReason:req.cancelReason})
                if(updateEnquiry.affected){
                    const enquiryLog = new EnquiryLogEntity()
                    const enquiryEntity = new EnquiriesEntity()
                    enquiryEntity.enquiryId = req.enquiryId
                    enquiryLog.enquiryEntity = enquiryEntity
                    enquiryLog.enquiryNumber = req.enquiryNumber
                    enquiryLog.enquiryStatus = EnquiryLifecycleStatusEnum.CANCELLED
                    await this.enquiryLogRepo.save(enquiryLog)
                    return new EnquiryAssessmentResponseModel(true, 1, `${req.enquiryNumber} cancelled successfully`)
                }
            }else{
                return new EnquiryAssessmentResponseModel(false, 0, 'No data found',[])
            }
            return
        }catch(err){
            throw(err)
        }
    }

    async getCountPricesInfo():Promise<CommonResponse>{
        try{
            const info = await this.enquiryRepo.getCostPriceInfo()
            interface priceInfoModel{
                count:string,
                price:number,
                colorVar : boolean,
                uploadedDate : any
            }
            let priceInfo:priceInfoModel[] = []; 
            let prevCount
            let prevPrice = 0
            let countVal
            let sameCounts:number[] = []
            let colorVal
            if(info){
                for(const priceRec of info){
                    if(prevPrice == priceRec.price){
                        sameCounts.push(prevCount) 
                        countVal = Math.min(...sameCounts)+'-'+priceRec.count  
                        priceInfo.splice(-1)
                        colorVal = true
                    }else{
                        sameCounts = []
                        countVal = priceRec.count   
                        colorVal = false                            
                    }
                    priceInfo.push({count:countVal,price:priceRec.price,colorVar:colorVal,uploadedDate: moment(priceRec.updated_at).format('YYYY-MM-DD')})
                    prevCount = priceRec.count
                    prevPrice = priceRec.price
                }

                return new CommonResponse(true,1,'Data retrieved',priceInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getAllEnquiryDetailsById(req: EnquiryIdreq):Promise<CommonResponse>{
        try{
            const enquiryDetails = await this.enquiryRepo.getEnquiryDetailsById(req);

            const enquiryData = enquiryDetails[0];
console.log(enquiryData ,"currencyName at 601");
const responseData =[]

            const productsData = await this.enquiryRepo.getProductByEnqId(req);
        const productDetails: EnquiryProductModel[] = productsData.map((product: any) => {
            const priceBasis = UnitsOfWeightInput.find(e => e.value == product.price_based_on).name == 'lb' ? 'LBS' : 'KGS'
            return new EnquiryProductModel(product.productId,product.enquiryId,product.category,product.brandId,product.brandName,
                product.variantId,product.variantName,product.shortCode,product.packStyleId,product.packStyleName,product.uomId,product.uomName,product.styleWeighment,product.unitPrice,product.noOfCases,
                product.caseWeight,product.netWeight,product.netAmount,product.noOfSkewers,product.varietyId,product.varietyName,product.netShrimpWeight,product.packCount,product.packMaterialCost,product.group,product.noOfContainers,product.sizeName,product.orderType,product.brandType,product.uv_price_category,product.uv_type,product.uv_percent_or_cent,product.no_of_pouches,product.pouches_per_row,priceBasis 
            );
        });

        // const packBomData = await this.enquiryRepo.getPackBomByEnqId(req);
        // const enquiryPackBom: EnquiryPackBomModel[] = packBomData.map((packBom: any) => {
        //     return new EnquiryPackBomModel(packBom.id,packBom.itemCategoryId,packBom.itemCategory,packBom.itemSubCategoryId,
        //         packBom.itemSubCategory,packBom.itemId,packBom.itemName,packBom.quantity,packBom.enquiryId
        //     );
        // });

        const enquiryByIdModel = new EnquiryByIdModel(enquiryData.enquiryId,enquiryData.orderType,enquiryData.sourceFrom,enquiryData.agentId,
            enquiryData.clientName,enquiryData.buyerId,enquiryData.endCustomerName,enquiryData.salePersonId,
            enquiryData.enquiryDate,enquiryData.etd,enquiryData.toEtd,enquiryData.eta,enquiryData.agentAddressId,enquiryData.agentAddress,
            enquiryData.buyerAddressId,enquiryData.buyerAddress,enquiryData.countryId,enquiryData.countryName,enquiryData.destinationId,
            enquiryData.destinationName,enquiryData.deliveryTermsId,enquiryData.deliveryTermsName,enquiryData.paymentTermsId,
            enquiryData.paymentTermsName,enquiryData.shipmentTermsId,enquiryData.shippingTermName,enquiryData.processingUnitId,
            enquiryData.processingUnit,enquiryData.manufacturingUnitId,enquiryData.manufacturingUnit,enquiryData.currencyId,enquiryData.currencyName,
            enquiryData.noOfContainers,enquiryData.salesCommission,enquiryData.remarks,productDetails,enquiryData.uomId,enquiryData.uom,
            enquiryData.unitName,
            enquiryData.rejectReason,
            enquiryData.enquiryNumber,enquiryData.company,enquiryData.enqRejectDes,enquiryData.isFOB == 0 ? false : enquiryData.isFOB == 1 ?  true : enquiryData.isFOB
        );

                responseData.push(enquiryByIdModel)
        // console.log(responseData,'service')
            return new CommonResponse(true,1,'Data retrieved successfully', responseData)
        }catch(err){
            throw(err)
        }
    }

    async getLeadProductInfoModelByEnquiryId(req:EnquiryIdreq):Promise<CommonResponse>{
        try{
            const productsData = await this.enquiryProductRepo.getLeadProdctInfoByEnquiryId(req)
            const leadData  = await this.enquiryRepo.getEnquiryDetailsById(req)
            const productinfo =[]
            const enquiryInfo = []
            if(productsData.length > 0){
                for(const rec of productsData){
                    productinfo.push(new LeadProductInfoModel(rec.product_id,rec.grade_min_count,rec.grade_max_count,rec.food_type_id,rec.value_addition_one_id,rec.value_addition_two_id,rec.value_addition_three_id,rec.value_addition_four_id,rec.value_addition_five_id,rec.no_of_pouches,rec.no_of_case,rec.case_weight,rec.net_weight,rec.net_amount,rec.pouches_per_row,1,rec.unit_price,rec.brand_id,rec.uom_id,rec.min_glaze,rec.max_glaze,rec.soaking_time,rec.soaking_style,rec.style_weighment,rec.variant_id,rec.no_of_skewers,rec.net_shrimp_weight,rec.master_brand_id,rec.loss_or_gain_percentage,rec.category,rec.required_count,rec.pack_style_id,rec.no_of_case,null,null,null,rec.variant_code,rec.uom_name,rec.variety_id,rec.size_name,rec.variety_id,rec.group,rec.no_of_containers,rec.confirmed_containers,rec.pack_count,rec.variant_code,rec.packing_method_name,rec.is_so_created,true,rec.price_based_on))
                }
                enquiryInfo.push(leadData[0])
                enquiryInfo[0].productDetails = productinfo
                return new CommonResponse(true,1,'Data retrievd',enquiryInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getEnqProductConfirmedContainersInfo(req:EnquiryIdreq):Promise<CommonResponse>{
        console.log(req,'req')
        const manager = getManager()
        try{
            // const getInfo = await this.enquiryProductRepo.find({where:{enquiryEntity:{enquiryId:req.enquiryid},isSocreated:false}})
            const getInfoQuery = `select enquiry_product_id from ${appSettings.enquiry_db} .enquiry_products where enquiry_id = ${req.enquiryid} and is_so_created = false`
            const getInfo =await manager.query(getInfoQuery)
            if(getInfo.length > 0){
                return new CommonResponse(true,1,'Data retrieved')
            }else{
                return new CommonResponse(false,1,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async updateProductSoCreationStatus(req:EnquiryIdreq):Promise<CommonResponse>{
        const manager = new GenericTransactionManager()
        try{
            await manager.startTransaction()
            let saveFlag = new Set<boolean>()
            const getEnquiryProductIdsInfo = await manager.getRepository(EnquiryProdctsEntity).find({select:['enquiryProductId'],where:{enquiryEntity:{enquiryId:req.enquiryid},group:req.productContainerGroup}})
            if(getEnquiryProductIdsInfo.length >0){
                for(const rec of getEnquiryProductIdsInfo){
                    const update = await manager.getRepository(EnquiryProdctsEntity).update({enquiryProductId:rec.enquiryProductId},{isSocreated:true})
                    if(!update.affected){
                        saveFlag.add(false)
                        await manager.releaseTransaction()
                        return new CommonResponse(false,0,'Something went wrong in updation')
                    }
                }
                if(!(saveFlag.has(false))){
                    await manager.completeTransaction()
                    return new CommonResponse(true,1,'Updated successfully')
                }
            }else{
                await manager.releaseTransaction()
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            await manager.releaseTransaction()
            throw err
        }
    }

    async getFreezeUnFreezeEnquiryNumberDropdown(req:FreezeUnFreezeInfoReq):Promise<CommonResponse>{
        try{
            const info = await this.enquiryRepo.getFreezeUnFreezeEnquiryNumberDropdown(req)
            if(info.length > 0){
                return new CommonResponse(true,1,'Data retreievd',info)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

}